import React from "react";
import { HubCancelSubmitGroup } from "../../components";
import { useFormContext } from "react-hook-form";

const MergePartButtons = ({ disabled = false }) => {
  const { formState } = useFormContext();
  const { isValid } = formState;

  return (
    <HubCancelSubmitGroup label="Merge Parts" disabled={!isValid || disabled} />
  );
};

export default MergePartButtons;
